module.exports = __webpack_public_path__ + "static/media/3-1.77fd7f92.webp";